import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';

const ICON_CONTAINER_SIZE = 160;

const styles = (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh',
    width: '100vw',
    top: 0,
    left: 0,
    position: 'fixed',
    backgroundColor: theme.palette.common.white,

  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(15),
    height: '100%',
    maxWidth: theme.dimensions.lg,
    gap: theme.spacing(2),
  },
  alertTitle: {
    marginBottom: theme.spacing(2),
  },
  iconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.facet.accentBlue21,
    width: ICON_CONTAINER_SIZE,
    height: ICON_CONTAINER_SIZE,
    borderRadius: '100%',
    fontSize: theme.typography.h1.fontSize,
    marginBottom: theme.spacing(4),
  },
  actionComponentWrapper: {
    width: '100%',
    display: 'flex',
    flexGrow: 1,
    alignItems: 'flex-end',
    marginTop: theme.spacing(2),
  },
  messageWrapper: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'flex-end',
  },
  icon: {
    fontSize: ICON_CONTAINER_SIZE / 2,
  },
});

const SubscriptionPaymentAlert = ({
  className,
  classes,
  icon,
  title,
  subTitle,
  message,
  actionComponent,
  TitleTypographyProps,
  SubTitleTypographyProps,
  MessageTypographyProps,
}) => {
  const ActionComponent = () => actionComponent;

  useScrollTopOnMount();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Box className={classes.content}>
        {/* ------- Icon Header ------- */}
        <div className={classes.iconWrapper}>
          <Icon
            icon={icon}
            className={classes.icon}
          />
        </div>

        {/* ------- Alert (title / subtitle) ------- */}
        <div>
          <div className={classes.alertTitle}>
            <Typography
              {...TitleTypographyProps}
            >
              {title}
            </Typography>
          </div>
          <Typography
            {...SubTitleTypographyProps}
          >
            {subTitle}
          </Typography>
        </div>

        {/* ------- Alert Message ------- */}
        {message ? (
          <div className={classes.messageWrapper}>
            <Typography
              {...MessageTypographyProps}
              test={'subscription-setup-payment-alert-message'}
            >
              {message}
            </Typography>
          </div>
        ) : null}

        {/* ------- Action ------- */}
        {actionComponent && (
          <div className={classes.actionComponentWrapper}>
            <ActionComponent />
          </div>)
        }
      </Box>
    </Box>
  );
};

SubscriptionPaymentAlert.defaultProps = {
  className: '',
  actionComponent: null,
  TitleTypographyProps: {
    weight: 'bold',
    variant: 'h1',
    color: 'primary',
    align: 'center',
  },
  SubTitleTypographyProps: {
    variant: 'h5',
    color: 'primary',
    weight: 'book',
    align: 'center',
  },
  MessageTypographyProps: {
    variant: 'h5',
    color: 'primary',
    weight: 'book',
    align: 'center',
  },
  message: undefined,
};

SubscriptionPaymentAlert.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  title: PropTypes.node.isRequired,
  subTitle: PropTypes.node.isRequired,
  message: PropTypes.string,
  actionComponent: PropTypes.node,
  SubTitleTypographyProps: PropTypes.object,
  TitleTypographyProps: PropTypes.object,
  MessageTypographyProps: PropTypes.object,
};

export default withStyles(styles)(SubscriptionPaymentAlert);
